const QxHome = () => import('@/components/QxHome.vue')
const Media = () => import('@/components/Media.vue')
const MediaEdit = () => import('@/components/MediaEdit.vue')
const Adzone = () => import('@/components/Adzone.vue')
const Report = () => import('@/components/Report.vue')
const Page403 = () => import('@/components/Page403.vue')
const Page404 = () => import('@/components/Page404.vue')
const Login = () => import('@/components/Login.vue')
const AdzoneEdit = () => import('@/components/AdzoneEdit.vue')
const AccessGuide = () => import('@/components/AccessGuide.vue')
const AccountEdit = () => import('@/components/AccountEdit.vue')

let route = {
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {title: "登录", requiresAuth: false}
        },
        {
            path: '/403',
            name: '403',
            component: Page403,
            meta: {title: "无权限", requiresAuth: false}
        },
        {
            path: '/',
            component: QxHome,
            meta: {requiresAuth: true},
            children: [
                {
                    path: '',
                    name: 'report',
                    component: Report,
                    meta: {title: "数据报表(Data Chart)"}
                },
                {
                    path: 'media',
                    name: 'media',
                    component: Media,
                    meta: {title: "媒体管理(Media Management)"}
                },
                {
                    path: 'media/new',
                    name: 'mediaNew',
                    component: MediaEdit,
                    meta: {title: "新建媒体(Create Media)"}
                },
                {
                    path: 'media/:mediaId',
                    name: 'mediaEdit',
                    component: MediaEdit,
                    meta: {title: "编辑媒体(Edit Media)"}
                },
                {
                    path: 'adzone',
                    name: 'adzone',
                    component: Adzone,
                    meta: {title: "广告位管理(Adzone Management)"}
                },
                {
                    path: 'adzone/new',
                    name: 'adzoneNew',
                    component: AdzoneEdit,
                    meta: {title: "新建广告位(Create Adzone)"}
                },
                {
                    path: 'adzone/:adzoneId',
                    name: 'adzoneEdit',
                    component: AdzoneEdit,
                    meta: {title: "编辑广告位(Edit Adzone)"}
                },
                {
                    path: 'accessGuide',
                    name: 'accessGuide',
                    component: AccessGuide,
                    meta: {title: "数据报表(Data Chart)"}
                },
                {
                    path: 'account',
                    name: 'account',
                    component: AccountEdit,
                    meta: {title: "账户管理(Account Management)"}
                }
            ]
        },
        {
            path: '*',
            name: '404',
            component: Page404,
            meta: {title: "找不到页面"}
        }
    ]
}

export default route
